import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';

@Component({
  selector: 'apd-button-stroked',
  templateUrl: './stroked.component.html',
  styleUrls: ['./stroked.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ButtonStrokedComponent {
  // custom props
  @Input() label: string;

  // flexLayout props
  @Input() mdFlex: string;
  @Input() smFlex: string;
  @Input() xsFlex: string;
  @Input() defaultClass: string;
  @Input() fullWidth = false;
  @Input() fullHeight = false;
  @Input() mdClass: string;
  @Input() smClass: string;
  @Input() xsClass: string;
  @Input() id: string;

  // material props
  @Input() disabled: boolean;
  @Output() clickEventHandler = new EventEmitter<void>();

  onClick(): void {
    this.clickEventHandler.emit();
  }
}
